class CartAutoAddManager {
  constructor() {
    this.triggerVariantId = 56269050118521;
    this.autoAddVariantId = 56215983489401;
    this.discountCode = 'Free brush';
    this.isProcessing = false;
    this.init();
  }

  init() {
    if (!window.routes || !window.routes.cart_url) {
      setTimeout(() => this.init(), 100);
      return;
    }
    
    setTimeout(() => {
      this.checkCartState();
    }, 500);
    
    subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
  } 

  async checkCartState() {
    if (this.isProcessing) return;

    try {
      const response = await fetch(`${window.routes.cart_url}.js`);
      const cartData = await response.json();
      this.processCartData(cartData);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  handleCartUpdate(event) {
    if (this.isProcessing) return;
    
    setTimeout(() => {
      this.checkCartState();
    }, 100);
  }

  async processCartData(cart) {
    console.log('CartAutoAdd: Processing cart data', cart);
    
    if (!cart || !cart.items) {
      console.log('CartAutoAdd: No cart items found');
      return;
    }

    const hasTriggerItem = cart.items.some(
      item => item.variant_id === this.triggerVariantId || item.id === this.triggerVariantId
    );
    console.log('CartAutoAdd: Has trigger item:', hasTriggerItem);

    const autoAddedGiftItem = cart.items.find(
      item => (item.variant_id === this.autoAddVariantId || item.id === this.autoAddVariantId) &&
        item.properties && item.properties.IsfreeGift === 'true'
    );
    const hasAutoAddedGift = !!autoAddedGiftItem;
    console.log('CartAutoAdd: Has auto-added gift:', hasAutoAddedGift);

    const hasAnyGiftItem = cart.items.some(
      item => item.variant_id === this.autoAddVariantId || item.id === this.autoAddVariantId
    );
    console.log('CartAutoAdd: Has any gift item:', hasAnyGiftItem);

    let actionRequired = false;
    let endpoint = '';
    let body = {};

    if (hasTriggerItem && !hasAutoAddedGift) {
      actionRequired = true;
      endpoint = window.routes.cart_add_url;
      body = {
        items: [{}]
      };
      
      const existingGiftItem = cart.items.find(
        item => (item.variant_id === this.autoAddVariantId || item.id === this.autoAddVariantId) &&
          (!item.properties || item.properties.IsfreeGift !== 'true')
      );
      
      if (existingGiftItem) {
        endpoint = window.routes.cart_change_url;
        body = {
          id: existingGiftItem.key,
          quantity: 1,
          properties: {
            'IsfreeGift': 'true'
          }
        };
      } else {
        body.items[0] = {
          id: this.autoAddVariantId,
          quantity: 1,
          properties: {
            'IsfreeGift': 'true'
          }
        };
      }
    } else if (!hasTriggerItem && hasAutoAddedGift) {
      actionRequired = true;
      endpoint = window.routes.cart_change_url;
      body = {
        id: autoAddedGiftItem.key,
        quantity: 0
      };
    }

    if (actionRequired) {
      console.log('CartAutoAdd: Action required', { endpoint, body });
      this.isProcessing = true;
      try {
        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript'
          }
        };

        const sections = this.getSectionsToRender();

        if (sections.length > 0) {
          config.body = JSON.stringify({
            ...body,
            sections: sections.map((s) => s.id).join(',')
          });
        } else {
          config.body = JSON.stringify(body);
        }

        console.log('CartAutoAdd: Making request to', endpoint, config.body);
        const response = await fetch(endpoint, config);
        let parsedState = await response.json();
        console.log('CartAutoAdd: Response received', parsedState);

        if (window.location.pathname === window.routes.cart_url) {
          window.location.reload();
        } else {
          this.updateCartDrawer(parsedState);
        }
      } catch (error) {
        console.error('Error auto-updating cart:', error);
      } finally {
        this.isProcessing = false;
      }
    }
  }

  getSectionsToRender() {
    const isCartDrawerEnabled = document.querySelector('cart-drawer');
    if (!isCartDrawerEnabled) return [];

    return [
      { id: 'cart-drawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  updateCartDrawer(parsedState) {
    const isCartDrawerEnabled = document.querySelector('cart-drawer');
    if (!isCartDrawerEnabled) return;

    if (parsedState && parsedState.sections) {
      const cartDrawerElement = document.querySelector('cart-drawer');
      if (cartDrawerElement) {
        const cartDrawerInner = cartDrawerElement.querySelector('.drawer__inner');
        if (cartDrawerInner && parsedState.sections['cart-drawer']) {
          cartDrawerInner.innerHTML = this.getSectionHTML(parsedState.sections['cart-drawer'], '.drawer__inner');
        }
      }

      const cartIconBubble = document.querySelector('#cart-icon-bubble');
      if (cartIconBubble && parsedState.sections['cart-icon-bubble']) {
        cartIconBubble.innerHTML = this.getSectionHTML(parsedState.sections['cart-icon-bubble'], '#shopify-section-cart-icon-bubble');
      }
    }

    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', {
      bubbles: true,
      composed: true
    }));
  }

  getSectionHTML(html, selector) {
    const template = document.createElement('template');
    template.innerHTML = html;
    return template.content.querySelector(selector)?.innerHTML || '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.cartAutoAddManager === 'undefined') {
    window.cartAutoAddManager = new CartAutoAddManager();
  }
});
 